/* eslint-disable no-useless-escape */
import { mixed, object } from 'yup'

export const shareSchema = object().shape({
  emails: mixed().test({
    message: 'Invalid email(s)',
    test: (value) => value?.length && value.every((item: any) => /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(item))
  })
})
